import { getDevicePrefs } from "./devicePrefs";

// The wall is used with fingers: holding one down shouldn't open the browser's
// right-click menu or start selecting page text (text boxes still select).
// Phones and laptops keep their menus for copying links and text.
export function installWallTouch() {
  if (!getDevicePrefs().wallComputer) return;
  document.documentElement.classList.add("wall");
  document.addEventListener("contextmenu", (e) => e.preventDefault(), true);
}
